import {
  getRoomTypeTabData,
  getSoldOutRooms,
} from "@Pages/PropertyPage/components/RoomTypeSection/utils";

/**
 * Room types in the order the property page lists them, which is what the panel's previous / next
 * arrows walk (FR-6): grouped by unit type in first-seen order, and inside each group the
 * available rooms before the sold-out ones. Sold-out rooms are included even though the page may
 * collapse them behind "view more".
 */
const getRoomNavigationOrder = (rooms: any[] = []): any[] => {
  const tabs = getRoomTypeTabData(rooms || []);
  return Object.keys(tabs)
    .filter((tab) => tab !== "all")
    .flatMap((tab) => {
      const [available, soldOut] = getSoldOutRooms(tabs[tab]);
      return [...available, ...soldOut];
    });
};

export default getRoomNavigationOrder;
